import styles from './index.module.scss';
import { useRouter } from 'next/router';
import { useLang } from '@/app/utils/useLang';
import EFPicture from '@elem/compCommon/EFPicture';
import { Pagination } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import Link from 'next/link';

const Explore: React.FC = () => {
    const { t } = useLang('landingPage.explore');
    const { locale = 'ca' } = useRouter();
    const items = [
        {
            img: 'https://websiteoss.ecoflow.com/_next/static/media/AC.99aedc05.png',
            title: 'EcoFlow AC Generator Charging Adapter',
            learnMore: 'https://ca.ecoflow.com/products/ac-generator-charging-adapter',
        },
        {
            img: 'https://websiteoss.ecoflow.com/_next/static/media/50AmpHub.b2c8a047.png',
            title: 'EcoFlow 50 Amp Hub',
            learnMore: 'https://ca.ecoflow.com/products/50-amp-hub',
        },
        {
            img: 'https://websiteoss.ecoflow.com/upload/image/1744100196870/EV%20X-Stream%20Adapter%20(DELTA%20Pro%20Ultra).png',
            title: 'EcoFlow EV X-Stream Adapter (DELTA Pro Ultra)',
            learnMore: 'https://ca.ecoflow.com/products/ev-x-stream-adapter-delta-pro-ultra',
        },

        {
            img: 'https://websiteoss.ecoflow.com/upload/image/1744100496621/EV%20X-Stream%20Adapter%20(DELTA%20Pro).png',
            title: 'EcoFlow EV X-Stream Adapter (DELTA Pro)',
            learnMore: 'https://ca.ecoflow.com/products/ev-x-stream-adapter-delta-pro',
        },
        {
            img: 'https://websiteoss.ecoflow.com/upload/image/1744100393156/power-input.png',
            title: 'EcoFlow Power Input/Output Cable',
            learnMore: 'https://ca.ecoflow.com/products/power-input-output-cable',
        },
        {
            img: 'https://websiteoss.ecoflow.com/_next/static/media/11_5.69002caf.webp',
            title: 'EcoFlow Portable Power Station \nGrounding Adapter',
            learnMore: 'https://ca.ecoflow.com/products/portable-power-station-grounding-adapter',
        },
        {
            img: 'https://websiteoss.ecoflow.com/upload/image/1744100583494/image%205154398.png',
            title: 'EcoFlow Smart Generator Adapter',
            learnMore: 'https://ca.ecoflow.com/products/delta-pro-to-smart-generator-adapter',
        },
        {
            img: 'https://websiteoss.ecoflow.com/upload/image/1744100601316/Trolley%20(DELTA%20Pro%20Ultra).png',
            title: 'EcoFlow Trolley (DELTA Pro Ultra)',
            learnMore: 'https://ca.ecoflow.com/products/trolley-delta-pro-ultra',
        },
    ];

    function handleLink(link: string) {
        window.open(link, '_blank');
    }

    return (
        <div className={styles.Explore}>
            <div className="explore-wrapper">
                <div className="title">{t('title')} </div>

                <div className="wrapper-pc">
                    <Swiper
                        slidesPerView={'auto'}
                        centeredSlides={false}
                        spaceBetween={27}
                        pagination={{
                            clickable: true,
                        }}
                        modules={[Pagination]}
                    >
                        {items.map((item) => {
                            return (
                                <SwiperSlide key={item.title}>
                                    <div className="item">
                                        <div className="inner-wrapper">
                                            <EFPicture src={item.img} />
                                            <div className="item-title">{item.title}</div>
                                        </div>
                                        <Link className="button" href={item.learnMore} target="_blank">
                                            Learn more
                                        </Link>
                                    </div>
                                </SwiperSlide>
                            );
                        })}
                    </Swiper>
                </div>
                <div className="wrapper-h5">
                    {items.map((item) => {
                        return (
                            <div key={item.title} className="item">
                                <div className="inner-wrapper">
                                    <EFPicture src={item.img} />
                                    <div className="item-title">{item.title}</div>
                                </div>
                                <Link className="button" href={item.learnMore} target="_blank">
                                    Learn more
                                </Link>
                            </div>
                        );
                    })}
                </div>
            </div>
        </div>
    );
};

export default Explore;
